import { z } from 'zod';

export const mentionSuggestionSchema = z.object({
  type: z.enum(['USER', 'BUSINESS']),
  id: z.string(),
  username: z.string(),
  displayName: z.string(),
  avatarUrl: z.string().nullable(),
  town: z.string().nullable(),
  isVerified: z.boolean(),
  isFollowing: z.boolean(),
});

export const mentionSuggestionsSchema = z.array(mentionSuggestionSchema);

export type MentionSuggestion = z.infer<typeof mentionSuggestionSchema>;
